import { PLP_ROOT_IDS } from "./consts";

const getPLPRoot = () => {
  for (const rootId of PLP_ROOT_IDS) {
    const element = document.getElementById(rootId);
    if (element) {
      return element;
    }
  }
  return null;
};
export default getPLPRoot;
